// This is my custom csv export component
const MyExportCSV = props => {
  const handleClick = () => {
    props.onExport()
  }
  return (
    <div className="text-sm-end">
      <button
        type="button"
        className="btn btn-success btn-label btn-lg font-12"
        onClick={handleClick}
      >
        <i className="mdi mdi-file-export-outline label-icon"></i> Export Data
      </button>
    </div>
  )
}

export default MyExportCSV
